// extracted by mini-css-extract-plugin
export default {"containerBody":"User_containerBody__w1+h9"};